window.animateSpeakerBubbles = function(elementSelector) {
  const frecuency = 1;
  const size = 184;
  const broke = 2;

  generate(400, 30);
  generate(240, 60);
  generate(300, 40);

  function generate(time, amplitude) {
    (function() {
      if ($("#bubbles-background")) $("#bubbles-background").remove();
      var $svg = elementSelector.append(
        '<svg id="bubbles-background" width="960" height="500"></svg>'
      );
      var svg = d3.select("#bubbles-background"),
        width = +svg.attr("width"),
        height = +svg.attr("height"),
        angles = d3.range(0, 2 * Math.PI, Math.PI / 200);

      var path = svg
        .append("g")
        .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")")
        .selectAll("path")
        .data(["#282607", "#282607"])
        .enter()
        .append("path")
        .attr("fill", function(d) {
          return d;
        })
        .datum(function(d, i) {
          return d3
            .radialLine()
            .curve(d3.curveLinearClosed)
            .angle(function(a) {
              return a;
            })
            .radius(function(a) {
              var t = d3.now() / time;

              return (
                size +
                Math.cos(a * frecuency - (i * 2 * Math.PI) / 5 + t) *
                  Math.pow((1 + Math.cos(a - t)) / broke, 3) *
                  amplitude
              );
            });
        });

      d3.timer(function() {
        if (!window.PLAYING) return;
        path.attr("d", function(d) {
          return d(angles);
        });
      });
    })();
    (function() {
      if ($("#bubbles-foreground")) $("#bubbles-foreground").remove();
      var $svg = elementSelector.append(
        '<svg id="bubbles-foreground" width="960" height="500"></svg>'
      );
      var svg = d3.select("#bubbles-foreground"),
        width = +svg.attr("width"),
        height = +svg.attr("height"),
        angles = d3.range(0, 2 * Math.PI, Math.PI / 200);

      var path = svg
        .append("g")
        .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")")
        .selectAll("path")
        .data(["RGBA(245, 107, 0, 1)", "RGBA(230, 145, 243, 1)"])
        .enter()
        .append("path")
        .attr("fill", function(d) {
          return d;
        })
        .style("mix-blend-mode", "color-dodge")
        .datum(function(d, i) {
          return d3
            .radialLine()
            .curve(d3.curveLinearClosed)
            .angle(function(a) {
              return a;
            })
            .radius(function(a) {
              var t = d3.now() / time;
              return (
                size +
                Math.cos(a * frecuency - (i * 2 * Math.PI) / 5 + t) *
                  Math.pow((1 + Math.cos(a - t)) / broke, 3) *
                  amplitude
              );
            });
        });

      d3.timer(function() {
        if (!window.PLAYING) return;
        path.attr("d", function(d) {
          return d(angles);
        });
      });
    })();
  }
};

window.clearBubbles = function() {
  $("#bubbles-background").remove();
  $("#bubbles-foreground").remove();
};
